module.exports = __webpack_public_path__ + "img/activityAdd-active.2df954c4.svg";